<template>
    <div id="organization-create-view" class="view form-view">
        <h2>{{ $t('createOrganization.title') }}</h2>

        <organization-form :form="form" :handler="createOrganization"></organization-form>
    </div>
</template>

<script>
import toast from '@/plugins/izitoast'
import OrganizationForm from '@/views/Organizations/components/OrganizationForm'
import OrganizationApi from '@/api/OrganizationApi'
import { mapGetters } from 'vuex'
import activeOrganizationData from '@/store/modules/activeOrganizationData'

const organizationApi = new OrganizationApi()

export default {
    name: 'OrganizationCreate',
    components: {
        OrganizationForm
    },
    mounted () {
        const UKTimeZone = this.getTimeZones.find(timeZone => 'Europe/London' === timeZone.id)
        if (null != UKTimeZone) {
            this.form.timeZone = UKTimeZone.id
        }
        const isMediaLicensePresent = activeOrganizationData.state().licenses.find(license => 'MEDIA_ACCESSIBILITY' === license.name)

        if (null != isMediaLicensePresent) {
            this.form.licenses = [isMediaLicensePresent.id]
        }
    },
    data () {
        return {
            form: {
                name: null,
                timeZone: null,
                supportEmail: null,
                supportPhoneNumber: null,
                licenses: null
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getTimeZones',
            'getLicenses'
        ])
    },
    methods: {
        async createOrganization (form) {
            const response = await organizationApi.createOrganization({
                name: form.name,
                timeZone: form.timeZone,
                supportEmail: form.supportEmail ? form.supportEmail : null,
                supportPhoneNumber: form.supportPhoneNumber ? form.supportPhoneNumber : null,
                isMainOrganization: false,
                licenses: form.licenses ? form.licenses : null
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('Organization successfully created.')
            if (this.hasAllRoles(['OrganizationUpdate'])) {
                this.$router.push('/settings/organizations/edit/' + response.payload)
            }
        }
    }
}
</script>

<style scoped lang="scss">
#organization-create-view {
    .content-wrapper {
        margin-right: 40px;
    }
}
</style>
